module.exports = __webpack_public_path__ + "static/media/unionbank.8eb9d295.svg";